module.exports = __webpack_public_path__ + "img/icon-faq-best.767c9573.svg";